import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MenuSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-viewer-interactive-area-list',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './interactive-area.component.html',
    styleUrls: ['./interactive-area.component.scss'],
    standalone: false
})
export class InteractiveAreaComponent {
  /**
   * Members
   */
  public expandedGroupId = '';

  /**
   * Constructor
   *
   * @param slideViewerFacade
   * @param menuSharedFacade
   */
  public constructor(public slideViewerFacade: SlideViewerFacade,
                     public menuSharedFacade: MenuSharedFacade) {
  }

  /**
   * Toggle Group
   *
   * @param groupId
   * @param showSelftest
   */
  public toggleGroup(groupId: string | null, showSelftest: boolean) {
    if (groupId === this.expandedGroupId) {
      this.expandedGroupId = '';
    } else {
      this.expandedGroupId = groupId;
    }
    if (showSelftest) {
      this.slideViewerFacade.requestSetAreaGroupId(groupId);
    }
  }

  /**
   * Set Area Group Id
   *
   * @param groupId
   * @param showSelftest
   */
  public setAreaGroupId(groupId: string | null, showSelftest: boolean) {
    if (!showSelftest) {
      this.slideViewerFacade.requestSetAreaGroupId(groupId);
    }
  }
}
